export default __webpack_public_path__ + "static/media/returnpolicy.751a55b6.svg";